import {Component, Input} from '@angular/core';
import {NgStyle} from "@angular/common";

@Component({
  selector: 'app-skeleton',
  standalone: true,
  imports: [
    NgStyle
  ],
  templateUrl: './skeleton.component.html',
  styleUrl: './skeleton.component.scss'
})
export class SkeletonComponent {
  private _width = '100px';

  @Input()
  set width(value: string | number) {
    this._width = typeof value === 'number' ? `${value}px` : value;
  }

  get width(): string {
    return this._width;
  }

  @Input() height = 20;
}
